import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'SpringLinks';
render(<App data-id="element-230" />, document.getElementById('root'));